module.exports = __webpack_public_path__ + "static/media/import-drop.2cbabfb4.png";